interface RenderSlotProps {
  readonly slot: React.ReactNode;
  readonly minEmptyHeight?: number;
}
const RenderSlot = ({ slot, minEmptyHeight }: RenderSlotProps) => {
  const Slot = slot as unknown as React.FC<Omit<RenderSlotProps, 'slot'>>;
  return <Slot minEmptyHeight={minEmptyHeight} />;
};

export { RenderSlot };
